<template>
  <section
    :title="$t('profiles.titles.artists')"
    class="two-col section-container relative"
    :class="{
      'no-paddings': windowWidth < 475
    }"
  >
    <h3 class="h3-titles font-museo-500 mb-8 xs:pl-0">
      <span>
        {{ $t("profiles.labels.poster") }}
      </span>
    </h3>
    <carousel
      :breakpoints="BREAKPOINTS.artistEventCard"
      :transition="500"
      :wrap-around="false"
      class="carousel fixed-carousel-arrows"
      @mousedown="handleMouseDown()"
      @mousemove="cancelOpen()"
      @mouseup="handleMouseUp()"
    >
      <slide
        v-for="(artist, index) in orderArtists"
        :key="artist.id"
        :aria-hidden="false"
      >
        <complete-artist-card
          v-if="artist"
          :artist="artist"
          :open-link="openArtist"
          :is-link="showLink"
          :open-external="true"
          :class="{ 'xs:ml-0 ml-[0.813rem]': index === 0 }"
        />
      </slide>
    </carousel>
    <!-- <div class="gradient-container">
      <div
        class="followers-gradient lg:inline-block hidden artist-gradient"
      ></div>
    </div> -->
  </section>
</template>

<script setup>
import { useEvent } from "@/composables/useEvent";
import { Carousel, Navigation, Slide } from "vue3-carousel";
import { BREAKPOINTS } from "@/constants.js";
import CompleteArtistCard from "@/components/wegow/ui/cards/CompleteArtistCard.vue";
import { onBeforeMount, onMounted, ref, computed } from "vue";
const { details: event } = useEvent();

const isClicking = ref(true);
const showLink = ref(true);
const windowWidth = ref(0);
windowWidth.value = window.innerWidth;

onBeforeMount(() => {
  window.removeEventListener("resize", updateScreen);
});
onMounted(() => {
  window.addEventListener("resize", updateScreen);
});

const updateScreen = () => {
  windowWidth.value = window.innerWidth;
};
const handleMouseDown = () => {
  isClicking.value = true;
};
const cancelOpen = () => {
  if (isClicking.value && showLink.value) {
    showLink.value = false;
  }
};
const handleMouseUp = () => {
  if (isClicking.value) {
    setTimeout(() => {
      isClicking.value = false;
      showLink.value = true;
    }, 250);
  }
};
const orderArtists = computed(() => {
  return event.value.artists.slice().sort((a, b) => {
    return b.followers_count - a.followers_count;
  });
});
</script>
<style lang="scss" scoped>
@import "@/components/general/ui/profiles/profiles.scss";
.carousel__slide {
  justify-content: start;
}
</style>
